import React from 'react'
import './footer.css'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {SiLeetcode} from 'react-icons/si'
import {BsInstagram} from 'react-icons/bs'
import { BsMedium } from 'react-icons/bs'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer_logo'>Muhammad Ahmad</a>
      <ul className='permalinks'>
        <li><a href='#'>Home</a></li>
        <li><a href='#about'>About Me</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#services'>Services</a></li>
        <li><a href='#creations'>Creations & Awards</a></li>
        <li><a href='#testimonials'>Testimonials</a></li>        
        <li><a href='#contact'>Contact Me</a></li>
      </ul>

      <div className='footer_socials'>


        <a href='https://www.linkedin.com/in/ahmad-alamgir-74241a392' target='_blanl'><BsLinkedin /></a>
        <a href='https://www.instagram.com/filmsbyahmad' target='_blanl'><BsInstagram /></a>

      </div>

      <div className='footer_copyright'>
        <small>Copyright &copy; 2023-26 muhammadahmad, All rights reserved.</small>
      </div>
    </footer>

  )
}

export default Footer